<template>
  <div>
    <v-radio-group v-model="welcome_theme.closed.text_justify" hide-details="">
      <template v-slot:label>
        รูปแบบการจัดวาง
      </template>
      <v-radio value="start">
        <template v-slot:label>
          <div>
            ชิดซ้าย
          </div>
        </template>
      </v-radio>
      <v-radio value="center">
        <template v-slot:label>
          <div>
            ตรงกลาง
          </div>
        </template>
      </v-radio>
      <v-radio value="end">
        <template v-slot:label>
          <div>
            ชิดขวา
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <v-checkbox
      v-model="welcome_theme.closed.swap_title"
      label="สลับข้อความหัวข้อกับคำอธิบาย"
    ></v-checkbox>
    <div>
      <v-card flat>
        <v-card-text class="px-0">
          ข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-text-field
            v-model="welcome_theme.closed.close_text"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-text class="pa-0">
          สีข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-color-picker
            v-model="welcome_theme.closed.close_text_color"
            class="my-6"
          ></v-color-picker>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["welcome_theme"],
};
</script>

<style lang="scss" scoped></style>
